import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const user = (state: RootState) => state.common.user;

export const currentUserSelector = createSelector(user, ({ user }) => user);

export const createdUserRequestSelector = createSelector(
  user,
  ({ createdUserRequest }) => createdUserRequest
);

export const currentSelectedUserSelector = createSelector(
  user,
  ({ selectedUser }) => selectedUser
);

export const currentUserCollectionSelector = createSelector(
  user,
  ({ userCollection }) => userCollection
);
